module.exports = __webpack_public_path__ + "img/32780342000168.51d3c46a.png";